module.exports = __webpack_public_path__ + "static/media/一种蓝牙写卡器.53cdc854.png";